var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnranked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 644,
    height: 727,
    viewBox: "0 0 644 727",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_743_909)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 517.16V209.05C0 189.4 10.48 171.25 27.5 161.42L294.33 7.36988C311.35 -2.45012 332.31 -2.45012 349.33 7.36988L616.16 161.42C633.18 171.24 643.66 189.4 643.66 209.05V517.16C643.66 536.81 633.18 554.96 616.16 564.79L349.33 718.84C332.31 728.66 311.35 728.66 294.33 718.84L27.5 564.79C10.48 554.97 0 536.81 0 517.16Z",
    fill: "#1C1128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3101 521.6V204.61L321.83 46.1201L596.34 204.61V521.6L321.83 680.09L47.3101 521.6Z",
    fill: "#342A44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.83 680.09L596.35 521.6L547.35 493.31L341.8 611.98C329.44 619.11 321.83 632.3 321.83 646.56V680.08V680.09Z",
    fill: "#1C1128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3101 521.6L321.83 680.09V646.57C321.83 632.3 314.22 619.12 301.86 611.99L116.28 504.84C103.92 497.71 88.7001 497.71 76.3501 504.84L47.3201 521.6H47.3101Z",
    fill: "#443B59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.83 79.6501V46.1201L47.3101 204.61L76.3401 221.37C88.7001 228.5 103.92 228.5 116.27 221.37L301.85 114.22C314.21 107.09 321.82 93.9001 321.82 79.6401L321.83 79.6501Z",
    fill: "#443B59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.34 521.6V204.61L567.31 221.37C554.95 228.5 547.34 241.69 547.34 255.95V499.48L596.34 521.59V521.6Z",
    fill: "#1C1128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.83 57.6701L586.35 210.39V515.83L321.83 668.55L57.3101 515.82V210.39L321.83 57.6701ZM321.83 46.1201L47.3101 204.61V521.59L321.83 680.08L596.35 521.59V204.61L321.83 46.1201Z",
    fill: "#443B59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.6 243.28L370.97 169.59C356.05 160.97 339.05 156.42 321.82 156.42C304.59 156.42 287.59 160.97 272.67 169.59L145.04 243.28C135.06 249.04 128.86 259.78 128.86 271.31V342.79C128.86 368.4 139.31 392.86 157.68 410.62V415.85C157.68 452.35 177.26 486.33 208.77 504.52L321.81 569.79L434.85 504.52C467.29 485.79 485.38 452.5 485.93 410.63C504.31 392.88 514.77 368.41 514.77 342.79V271.31C514.77 259.78 508.57 249.04 498.59 243.28H498.6Z",
    fill: "#1C1128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.82 369.11L166.86 281.92V342.8C166.86 362.9 177.58 381.47 194.99 391.53L321.82 464.75L448.65 391.53C466.06 381.48 476.78 362.91 476.78 342.8V281.92L321.82 369.11Z",
    fill: "#342A44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.82 464.74L195.69 391.92V415.85C195.69 438.96 207.92 460.15 227.78 471.61L321.82 525.91L415.86 471.61C435.72 460.15 447.95 438.96 447.95 408.65V391.91L321.82 464.73V464.74Z",
    fill: "#342A44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.87 299.02L316.93 377.83L321.83 380.59L326.73 377.83L466.78 299.02V342.79C466.78 359.27 457.92 374.62 443.65 382.86L442.96 383.26L437.96 386.15V408.66C437.96 433.95 428.59 452.73 410.87 462.96L321.83 514.37L232.79 462.96C216.08 453.31 205.7 435.26 205.7 415.86V386.15L200.7 383.26L200.01 382.86C185.74 374.62 176.88 359.27 176.88 342.79V299.02M476.8 281.92L321.84 369.11L166.88 281.92V342.8C166.88 362.9 177.6 381.47 195.01 391.53L195.7 391.93V415.86C195.7 438.97 207.93 460.16 227.79 471.62L321.83 525.92L415.87 471.62C435.73 460.16 447.96 438.97 447.96 408.66V391.92L448.65 391.52C466.06 381.47 476.78 362.9 476.78 342.79V281.91L476.8 281.92Z",
    fill: "#443B59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.29 261.04L321.83 336.98L453.37 261.04L351.98 202.5C333.32 191.73 310.34 191.73 291.68 202.5L190.29 261.04Z",
    fill: "#443B59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.97 202.5C342.64 197.11 332.23 194.42 321.82 194.42V336.98L453.36 261.04L351.97 202.5Z",
    fill: "#342A44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.83 281.92L195.59 264.1L321.83 336.98L448.06 264.1L321.83 281.92Z",
    fill: "#1C1128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.83 204.42C330.65 204.42 339.34 206.75 346.98 211.16L433.37 261.04L321.83 325.44L210.29 261.04L296.68 211.16C304.32 206.75 313.01 204.42 321.83 204.42ZM321.83 194.42C311.42 194.42 301.01 197.11 291.68 202.5L190.29 261.04L321.83 336.98L453.37 261.04L351.98 202.5C342.65 197.11 332.24 194.42 321.83 194.42Z",
    fill: "#443B59"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_743_909"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 643.65,
    height: 726.21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnranked);
export default __webpack_public_path__ + "static/media/unranked.ac2623299b250689293cd4a5e68fcc5b.svg";
export { ForwardRef as ReactComponent };